import { createContext, useContext, type ReactNode } from 'react';
import type { AppMode } from './app-mode';

/**
 * React-context-equivalent voor de Vue `provide('appMode', mode)` in
 * `main.ts`. Components consumeren via `useAppMode()` — handig voor
 * stukjes die mode-specifiek renderen (sidebar-nav, footer-tekst).
 */
const AppModeContext = createContext<AppMode>('tenant');

export function AppModeProvider({ mode, children }: { mode: AppMode; children: ReactNode }) {
  return <AppModeContext.Provider value={mode}>{children}</AppModeContext.Provider>;
}

export function useAppMode(): AppMode {
  return useContext(AppModeContext);
}
